import 'reflect-metadata';
import { Service } from 'typedi';
import { StrategyBuilder } from '../../StrategyBuilder';
import { makeLogger } from '../../../../logger/logger';
import {PassFacetStrategyService} from '../../PassFacetStrategyService';
import type {IPassFacetStrategyData} from '../../types/pass-facet-srategy-data.type';

const { debug } = makeLogger({
  pathToCurrentFile:
    'components/strategies/services/pass-facet-service/pass-facet-info.service.ts',
  loggersList: ['debug'],
});

@Service({ id: 'passFacetInfoStrategyService' })
export class PassFacetConfigurationBuilder extends StrategyBuilder<PassFacetStrategyService> {
  private ppp: null|PassFacetInfoStrategyService = null;
  build(
    details: IPassFacetStrategyData
  ): PassFacetStrategyService {
      if(this.ppp == null)
        this.ppp = new PassFacetInfoStrategyService(details);
      return this.ppp;
  }
}

export class PassFacetInfoStrategyService extends PassFacetStrategyService {
  details;

  constructor(details: IPassFacetStrategyData) {
      super();
      this.details = details;
  }

  private fallbackConfiguration = {
    strategyType: 'passFacetInfo',
    params: {
      facetName: '',
    },
  };

  //fallback
  private cbs:CallableFunction[] = [] ;
  private facetConditionsChildrenNames:string[] = [];


  public haveFacetConditionsChildrenNames(facetConditionsChildrenNames: string[]){
      if (Array.isArray(facetConditionsChildrenNames)) {
        this.facetConditionsChildrenNames = [...this.facetConditionsChildrenNames, ...facetConditionsChildrenNames];
        this.transfer();
      }
  }
  public register(cbk){
      this.cbs.push(cbk);
      this.transfer();
  }

  public resetFacetConditionsChildrenNames() {
      this.facetConditionsChildrenNames = [];
  }

  private transfer(){
      this.cbs.forEach(c=>c(this.facetConditionsChildrenNames));
  }
}
